import { RequiredOrProperty } from '@agroone/helpers'
import { plainToInstance } from 'class-transformer'

export class SaveReporting {
  public static build(raw: any) {
    return plainToInstance(SaveReporting, raw)
  }

  @RequiredOrProperty('updatedBy')
  createdBy?: number

  @RequiredOrProperty('createdBy')
  updatedBy?: number

  @RequiredOrProperty('updatedAt')
  createdAt?: string

  @RequiredOrProperty('createdAt')
  updatedAt?: string
}

export class SaveReportingV2 {
  public static build(raw: any) {
    return plainToInstance(SaveReporting, raw)
  }

  @RequiredOrProperty('updatedBy')
  createdBy?: number

  @RequiredOrProperty('createdBy')
  updatedBy?: number
}
